export const GAMESTATE = 'GAMESTATE'
export const SETTINGS = 'SETTINGS'
export const PLAYRUNE = 'PLAYRUNE'
export const PLAYEFFECT = 'PLAYEFFECT'
export const SCORE = 'SCORE'
